import { inject, Injectable } from '@angular/core';
import { AuthService } from '@common/services/auth.service';

@Injectable({
  providedIn: 'root',
  deps: [AuthService],
})
export class StorageService {
  $auth = inject(AuthService);

  composedKey(key: string): string {
    if (!this.$auth.sub()) {
      return key;
    }
    return `${this.$auth.sub()}-${key}`;
  }

  set(key: string, value: string): void {
    localStorage.setItem(this.composedKey(key), value);
  }

  get(key: string): string | null {
    return localStorage.getItem(this.composedKey(key));
  }
}
